export const fundinglines = {
  SOLAR: 'SOLAR',
  AERO: 'AERO',
  BATTERY: 'BATTERY',
  CHARGER: 'CHARGER',
}
export const fundinglinesList = ['SOLAR', 'AERO', 'BATTERY', 'CHARGER']

export const fundingTypes = {
  RENTING: 'RENTING',
  RENTINGFIJO: 'RENTINGFIJO',
  RENTINGVARIA: 'RENTINGVARIA',
  RENTINGFLEX: 'RENTINGFLEX',
}

export const customerFundingTypesList = ['FINANCED', 'LOAN', 'CREDITCONSUME', 'NOFEE', 'RENOVE']

export const customerFundingTypes = {
  FINANCED: 'FINANCED',
  LOAN: 'LOAN',
  CREDITCONSUME: 'CREDITCONSUME',
  NOFEE: 'NOFEE',
  RENOVE: 'RENOVE',
}
